import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function () {
    var e,
      o = _getPrototypeOf(t);
    if (r) {
      var s = _getPrototypeOf(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
import React from 'react';
import { Header, Button } from 'semantic-ui-react';
import Event, { EVENT_CATEGORIES } from '../../modules/analytics/components/Event';
import { EventPropType } from '../../modules/analytics/types';
import { classNames } from '../../utils/classname';
import IconElement from '../IconElement';
var ContactElement = /*#__PURE__*/function (_React$Component) {
  _inherits(ContactElement, _React$Component);
  var _super = _createSuper(ContactElement);
  function ContactElement() {
    _classCallCheck(this, ContactElement);
    return _super.apply(this, arguments);
  }
  _createClass(ContactElement, [{
    key: "renderLink",
    value: function renderLink() {
      var _this$props = this.props,
        contact = _this$props.contact,
        link = _this$props.link,
        iconType = _this$props.iconType,
        as = _this$props.as,
        iconPosition = _this$props.iconPosition,
        buttonColor = _this$props.buttonColor,
        fluidButton = _this$props.fluidButton,
        buttonSize = _this$props.buttonSize,
        event = _this$props.event;
      var _ref = event || {},
        _ref$category = _ref.category,
        category = _ref$category === void 0 ? EVENT_CATEGORIES.CONTACT_EVENT_CATEGORY : _ref$category,
        _ref$action = _ref.action,
        action = _ref$action === void 0 ? 'click' : _ref$action,
        _ref$label = _ref.label,
        label = _ref$label === void 0 ? link : _ref$label;
      var finalEvent = {
        category: category,
        action: action,
        label: label
      };

      // Button use case
      var iconProps = iconType === 'none' ? {} : {
        icon: iconType
      };
      var contentProps = as === 'icon' ? {} : {
        content: contact
      };
      var isPrimary = buttonColor === 'primary';
      var buttonColorProps = isPrimary ? {
        primary: true
      } : {
        secondary: true
      };
      if (as === 'text') {
        var header = /*#__PURE__*/React.createElement("a", {
          href: link
        }, /*#__PURE__*/React.createElement("p", null, contact));
        var textContent = iconType === 'none' || iconType === '' ? header : /*#__PURE__*/React.createElement(IconElement, {
          iconType: iconType,
          element: header,
          iconPosition: iconPosition
        });
        return /*#__PURE__*/React.createElement(Event, {
          event: finalEvent,
          eventType: "click"
        }, textContent);
      }
      return /*#__PURE__*/React.createElement(Event, {
        event: finalEvent,
        eventType: "click"
      }, /*#__PURE__*/React.createElement(Button, _extends({
        fluid: fluidButton,
        size: buttonSize,
        as: "a",
        href: link
      }, buttonColorProps, contentProps, iconProps)));
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var header = this.props.header;
      return /*#__PURE__*/React.createElement(Header, {
        as: "h2"
      }, header);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        className = _this$props2.className,
        header = _this$props2.header;
      var finalClassName = classNames(_defineProperty({
        email: true
      }, className, true));
      return header !== '' ? /*#__PURE__*/React.createElement("div", {
        className: finalClassName
      }, this.renderHeader(), this.renderLink()) : /*#__PURE__*/React.createElement("div", {
        className: finalClassName
      }, this.renderLink());
    }
  }]);
  return ContactElement;
}(React.Component);
export { ContactElement as default };
ContactElement.defaultProps = {
  as: 'text',
  buttonColor: 'primary',
  buttonSize: 'large',
  className: '',
  fluidButton: false,
  header: '',
  iconPosition: 'left',
  iconType: 'none',
  event: {
    category: 'Contact',
    action: 'click'
  }
};